// src/constants/options.ts

// メーカーの選択肢（マスタデータに移行済み、互換性のため残存）
// 新規実装では useManufacturerOptions() を使用してください
// export const MANUFACTURER_OPTIONS = [
//     'ダイキン',
//     '三菱電機',
//     '三菱重工',
//     '日立',
//     '東芝',
//     'Panasonic',
//     '三洋',
//     'ヤンマー',
//     'アイシン',
//     'ピーマック',
//     '木村工業',
//     '暖冷工業',
//     '富士通ゼネラル',
//     'コロナ',
//     'クボタ',
//     'ノーリツ',
//     'LG'
// ];

// タイプの選択肢
export const TYPE_OPTIONS = [
    '天カセ四方向',
    '天カセ二方向',
    '天カセ一方向',
    '天カセ四方向お掃除機能付き',
    '壁掛け',
    '天吊り',
    '天埋め',
    'ビルトイン',
    '床置き',
    'ルーム壁掛け',
    'ルーム壁掛けお掃除機能付き',
    'ルーム一方向',
    'ルーム二方向',
    'ユニットクーラー',
    'ファンコイル四方向',
    'ファンコイル二方向',
    'ファンコイル一方向',
    'ファンコイル天吊り',
    'ファンコイル天埋め',
    'ファンコイル床置き'
];

// 冷媒の選択肢
export const REFRIGERANT_OPTIONS = [
    'R410A',
    'R407C',
    'R22',
    'R32',
    'R404a',
    'R12',
    'R134a'
];

// 作業種類の選択肢（マスタデータに移行済み、互換性のため残存）
// 新規実装では useWorkTypeOptions() を使用してください
// export const WORK_TYPE_OPTIONS = [
//     'フィルター',
//     'エレメント',
//     'ダクト',
//     '換気扇',
//     '制気口',
//     '加湿器',
//     '防虫網',
//     '防鳥網',
//     '空気清浄機',
//     '全熱交換器',
//     'ユニットクーラー'
// ];

// 作業チェックオプション
export const WORK_LOCATION_CHECK_OPTIONS = {
    GOOD: '〇', // 全角の丸
    FAIR: '△',
    NONE: 'ー' // 全角のダッシュ
} as const;

// 作業チェックオプション
export const WORK_CHECK_OPTIONS = {
    GOOD: '〇', // 全角の丸
    FAIR: '△',
    BAD: '×', // 全角のバツ
    NONE: 'ー' // 全角のダッシュ
} as const;


export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250,
        },
    },
};